export default {
      id: "asscher-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#asscher",
      toString: function () {
        return this.url;
      }
    }